export const isTagTypeSelectionLengthEligible = (overallLength, isPontoon) =>
  isFinite(overallLength) && overallLength > 0 &&
  (overallLength < 26 || (isPontoon && overallLength > 26));




// WEBPACK FOOTER //
// ./src/app/Scenes/BoatManufacturer/Application/New/personPowerCapacityEligibility.js